import React, { useState } from 'react';
import { Accordion, Status, Text } from '@ui';
import { CHECKLIST_ITEM_KEY, CHECKLIST_STATUS } from '../shared/constants';
import { translatorFor } from '../shared/i18n';
import { LazyState, RefreshButton } from '../shared/LazySection';
const t = translatorFor('job_fields');
const FOUND_COLOR = 'green-500';
const MISSING_COLOR = 'yellow-500';
function jobFieldItems(verification) {
    var _a, _b;
    return ((_b = (_a = verification === null || verification === void 0 ? void 0 : verification.checklist) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).filter((item) => item.key.startsWith(CHECKLIST_ITEM_KEY.JOB_CUSTOM_FIELD_PREFIX));
}
export function JobFieldsCard({ checklist }) {
    const [expanded, setExpanded] = useState(false);
    const items = jobFieldItems(checklist.data);
    const toggle = (next) => {
        setExpanded(next);
        if (next)
            checklist.load();
    };
    const missingCount = items.filter((item) => item.status !== CHECKLIST_STATUS.OK).length;
    const preview = items.length === 0 ? t('preview_unknown') : t('preview', { count: missingCount });
    return (React.createElement(Accordion, { variant: "section", title: t('title'), previewContent: preview, isExpanded: expanded, onToggle: toggle },
        React.createElement("div", { className: "service-titan-settings__accordion-body" },
            React.createElement(LazyState, { loading: checklist.loading, error: checklist.error, onRetry: () => {
                    checklist.reload();
                } }),
            items.map((item) => {
                const found = item.status === CHECKLIST_STATUS.OK;
                return (React.createElement("div", { key: item.key, className: "service-titan-settings__list-row" },
                    React.createElement(Text, { variant: "body", as: "span" }, item.label),
                    React.createElement(Status, { label: found ? t('found') : t('missing'), color: found ? FOUND_COLOR : MISSING_COLOR })));
            }),
            missingCount > 0 && (React.createElement(Text, { variant: "body", as: "p" }, t('missing_help'))),
            checklist.data && (React.createElement(RefreshButton, { disabled: checklist.loading, onRefresh: () => {
                    checklist.reload();
                } })))));
}
export default JobFieldsCard;
